import React, { useState, useEffect } from "react";

export default function CURRENTAFFAIRStest(props) {
  const correctAnswers = [3, 2, 1, 0, 1, 2, 0, 3, 2, 1, 0, 0, 1, 2, 0, 0, 1, 1, 3, 1, 0, 0, 1, 0, 0];
  const que = {
    q1: {
      string: "1. Who won the Nobel Peace Prize in the year 2023?",
      options: ["Greta Thunberg", "Malala Yousafzai", "Jacinda Ardern", "World Food Programme"],
      ans: 3
    },
    q2: {
      string: "2. Which country hosted the 2024 Summer Olympics?",
      options: ["United States", "China", "France", "Australia"],
      ans: 2
    },
    q3: {
      string: "3. Who is the current Secretary-General of the United Nations?",
      options: ["Ban Ki-moon", "António Guterres", "Kofi Annan", "Ban Ki-moon"],
      ans: 1
    },
    q4: {
      string: "4. Which country became the first to make bitcoin legal tender?",
      options: ["El Salvador", "Uruguay", "Venezuela", "Argentina"],
      ans: 0
    },
    q5: {
      string: "5. Which country launched the Tianwen-1 mission to Mars?",
      options: ["India", "China", "Russia", "United States"],
      ans: 1
    },
    q6: {
      string: "6. Who won the 2024 Wimbledon Men's Singles title?",
      options: ["Roger Federer", "Rafael Nadal", "Novak Djokovic", "Andy Murray"],
      ans: 2
    },
    q7: {
      string: "7. Which country became the first to approve a COVID-19 vaccine for children under 12?",
      options: ["United States", "United Kingdom", "China", "Russia"],
      ans: 0
    },
    q8: {
      string: "8. Who won the 2023 Academy Award for Best Actor?",
      options: ["Leonardo DiCaprio", "Brad Pitt", "Joaquin Phoenix", "Will Smith"],
      ans: 3
    },
    q9: {
      string: "9. Which country launched the Chandrayaan-3 lunar mission?",
      options: ["China", "Russia", "India", "United States"],
      ans: 2
    },
    q10: {
      string: "10. Which city hosted the 2024 G20 Summit?",
      options: ["London", "Rome", "Tokyo", "New Delhi"],
      ans: 1
    },
    q11: {
      string: "11. Who won the 2024 UEFA European Football Championship?",
      options: ["Italy", "England", "France", "Germany"],
      ans: 0
    },
    q12: {
      string: "12. Which company became the world's first trillion-dollar company?",
      options: ["Apple", "Amazon", "Microsoft", "Google"],
      ans: 0
    },
    q13: {
      string: "13. Who was named the TIME Person of the Year for 2023?",
      options: ["Greta Thunberg", "Joe Biden", "Elon Musk", "Donald Trump"],
      ans: 1
    },
    q14: {
      string: "14. Which country hosted the 2023 ICC Cricket World Cup?",
      options: ["England", "Australia", "India", "South Africa"],
      ans: 2
    },
    q15: {
      string: "15. Which film won the Best Picture award at the 2023 Oscars?",
      options: ["Nomadland", "The Trial of the Chicago 7", "Minari", "Parasite"],
      ans: 0
    },
    q16: {
      string: "16. Who is the current President of France?",
      options: ["Emmanuel Macron", "François Hollande", "Nicolas Sarkozy", "Jacques Chirac"],
      ans: 0
    },
    q17: {
      string: "17. Which city hosted the 2023 Rugby World Cup?",
      options: ["London", "Paris", "Tokyo", "Sydney"],
      ans: 1
    },
    q18: {
      string: "18. Who won the 2023 Nobel Prize in Literature?",
      options: ["Bob Dylan", "Kazuo Ishiguro", "Margaret Atwood", "Haruki Murakami"],
      ans: 1
    },
    q19: {
      string: "19. Which country hosted the 2023 FIFA Women's World Cup?",
      options: ["United States", "France", "Australia", "Canada"],
      ans: 3
    },
    q20: {
      string: "20. Who is the current Prime Minister of Japan?",
      options: ["Shinzo Abe", "Yoshihide Suga", "Naoto Kan", "Junichiro Koizumi"],
      ans: 1
    },
    q21: {
      string: "21. Which country launched the Perseverance rover to Mars?",
      options: ["United States", "Russia", "China", "India"],
      ans: 0
    },
    q22: {
      string: "22. Who won the 2023 Ballon d'Or award for the world's best football player?",
      options: ["Lionel Messi", "Cristiano Ronaldo", "Neymar", "Kylian Mbappé"],
      ans: 0
    },
    q23: {
      string: "23. Which company became the first to reach a market capitalization of $3 trillion?",
      options: ["Apple", "Amazon", "Microsoft", "Google"],
      ans: 1
    },
    q24: {
      string: "24. Who won the 2023 Pulitzer Prize for Fiction?",
      options: ["Colson Whitehead", "Donna Tartt", "Hilary Mantel", "Chimamanda Ngozi Adichie"],
      ans: 0
    },
    q25: {
      string: "25. Which country launched the Artemis program to return humans to the Moon?",
      options: ["United States", "Russia", "China", "India"],
      ans: 0
    }
  };


  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>APTITUDE <span>CURRENT-AFFAIRS</span></h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
